<template>
  <section class="app-markdown">
    <section class="app-markdown-inner" :class="navList.length > 0 && 'has__nav'">
      <NuxtLink v-if="hasBack" class="app-markdown-back" :to="backToLink">
        <div class="app-markdown-back-button">
          <svg class="app-markdown-back-icon" viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.40006 5L6 0.660409L5.29997 -3.05993e-08L-2.18557e-07 5L5.29997 10L6 9.33959L1.40006 5Z"
            />
          </svg>
        </div>
        <span class="app-markdown-back-name">
          {{ backToName }}
        </span>
      </NuxtLink>
      <hr v-if="hasBack" class="app-markdown-hr" />
      <header
        v-if="title"
        :class="['app-markdown-header', subtitle && 'has__subtitle', hasBack && 'has__back', hasMenu && 'has__menu']"
      >
        <GfrButton v-if="hasMenu" class="app-markdown-menu-btn" @click="openDocumentMenu">
          <svg class="app-markdown-menu-icon" viewBox="0 0 26 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 3.81441L0 0H4.65638L26 20.0189L21.6361 24.1131L0 3.81441Z" fill="#FFBA00" />
            <path
              d="M17.3012 28.164L4.68543 40H0.00611383L0.00611383 36.234L12.9545 24.0914L17.3012 28.164Z"
              fill="#FFBA00"
            />
          </svg>
        </GfrButton>
        <GfrTitle class="app-markdown-title" :level="1" placement="left">
          {{ title }}
          <button
            v-if="usedNames?.length"
            ref="usedBtn"
            v-clickout="hideUsedBtn"
            class="app-markdown-used-btn"
            @click="openUsedBtn"
          >
            <svg class="app-markdown-used-icon" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="28" height="28" fill="#303237" />
              <rect x="6" y="6" width="16" height="16" stroke="#C8CCD3" stroke-width="1.5" />
              <rect x="9" y="15" width="5" height="1.5" fill="#C8CCD3" />
              <rect x="9" y="10" width="7" height="1.5" fill="#C8CCD3" />
            </svg>
            <Transition name="tran-fadeIn">
              <div v-show="usedInfoShow" :class="['app-markdown-used-info', usedListPlace]">
                <span class="app-markdown-used-title">{{ formatTransify('UGC_OFFICIAL_WEBSITE_USED_NAME') }}</span>
                <ul class="app-markdown-used-list">
                  <li v-for="(item, index) in usedNames" :key="index" class="app-markdown-used-name">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </Transition>
          </button>
        </GfrTitle>
        <GfrTitle v-if="subtitle" class="app-markdown-subtitle" :level="2" placement="left">{{ subtitle }}</GfrTitle>
      </header>
      <hr class="app-markdown-hr" />
      <CommonMarkdownTagWrapper v-if="tags" :data="tags"></CommonMarkdownTagWrapper>
      <p v-if="brief" class="app-markdown-brief">
        {{ brief }}
      </p>
      <!--  @nuxtjs/mdc 0.9.2（当前为最新版本）及以下版本在部分iOS系统客户端渲染失效  -->
      <!--      <MDC-->
      <!--        v-if="props.content"-->
      <!--        ref="markdown"-->
      <!--        :key="$route.params.id"-->
      <!--        :value="formatMarkdown"-->
      <!--        class="app-markdown-content"-->
      <!--      />-->
      <BaseMarkdownCtx ref="markdown" class="app-markdown-content" :content="formatHtml"></BaseMarkdownCtx>
      <footer v-show="pre || next" class="app-markdown-footer">
        <NuxtLink class="app-markdown-link pre" :class="pre && 'visible'" :to="pre?.url" :title="pre?.title">
          <svg class="app-markdown-link-icon" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 0H13.4353L6.60954 7L13.428 14H15.9927L16 0Z" fill="#FFBA00" />
            <path d="M8.30596 12.6661V13.9999H6.81843L0 6.99989L1.3941 5.56828L8.30596 12.6661Z" fill="#FFBA00" />
            <path d="M2.77891 4.1518L6.80915 0.013125H8.30401V1.32998L4.16751 5.57588L2.77891 4.1518Z" fill="#FFBA00" />
          </svg>
          <span class="app-markdown-link-text title">
            {{ pre?.title }}
          </span>
          <span class="app-markdown-link-text pre"> {{ formatTransify('UGC_OFFICIAL_WEBSITE_DOCUMENT_LAST') }} </span>
        </NuxtLink>
        <NuxtLink class="app-markdown-link next" :class="next && 'visible'" :to="next?.url" :title="next?.title">
          <svg class="app-markdown-link-icon" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 0H13.4353L6.60954 7L13.428 14H15.9927L16 0Z" fill="#FFBA00" />
            <path d="M8.30596 12.6661V13.9999H6.81843L0 6.99989L1.3941 5.56828L8.30596 12.6661Z" fill="#FFBA00" />
            <path d="M2.77891 4.1518L6.80915 0.013125H8.30401V1.32998L4.16751 5.57588L2.77891 4.1518Z" fill="#FFBA00" />
          </svg>
          <span class="app-markdown-link-text title">
            {{ next?.title }}
          </span>
          <span class="app-markdown-link-text next"> {{ formatTransify('UGC_OFFICIAL_WEBSITE_DOCUMENT_NEXT') }} </span>
        </NuxtLink>
      </footer>
    </section>
    <div v-if="navList.length > 0" class="app-markdown-aside">
      <div class="app-markdown-aside-inner">
        <div class="app-markdown-index">{{ formatTransify('UGC_OFFICIAL_WEBSITE_INDEX') }}</div>
        <nav ref="markdownNav" class="app-markdown-nav">
          <CommonMarkDownNav :nav-list="navList" :nav-active-index="navActiveIndex" @toggle-nav="toggleNav" />
        </nav>
      </div>
    </div>
  </section>
</template>
<script lang="ts" setup>
// import { parseMarkdown } from '@nuxtjs/mdc/runtime'

import { decodeHTML } from 'entities'
import { DocumentTags } from '~/server/types'
import { CatalogsConfig } from '~/stores/document'
import { Device } from '#imports'
interface NavListConfig {
  title: string
  url: string
  type: string
  index: number
  children?: NavListConfig[]
}
const props = defineProps<{
  id?: number
  hasBack?: boolean
  hasMenu?: boolean
  backToName?: string
  backToLink?: string
  title?: string
  subtitle?: string
  content?: string
  brief?: string
  tags?: DocumentTags
  next?: CatalogsConfig | null
  pre?: CatalogsConfig | null
  hasSubNav?: boolean
  usedNames?: string[]
}>()
const { formatTransify } = useStore()
const { openDocumentMenu } = useDocumentStore()
const usedBtn = ref<HTMLElement>()
const usedListPlace = ref<'left' | 'right' | ''>('')
const usedInfoShow = ref(false)
const markdown = ref<HTMLElement>()
const markdownNav = ref<HTMLElement>()
const navActiveIndex = ref(-1)
let toggling = false
const formatMarkdown = computed(() => {
  return props.content
    ?.replace(/```golang([\s\S]*?)```/g, function (_, p1) {
      return '```go' + p1 + '\n```'
    }) // markdown-it 不支持加粗、斜体、斜体加粗的结束符前有特殊字符，会导致解析错误，为避免此类情况，判断此类语法直接转化成html
    .replace(/(\*\*\*|\*\*|\*)(.*?)(\*\*\*|\*\*|\*)/g, function (_: any, p1: string, p2) {
      if (p1 === '***') {
        return `<strong><em>${p2}</em></strong>`
      }
      if (p1 === '**') {
        return `<strong>${p2}</strong>`
      }
      return `<em>${p2}</em>`
    })
})
const { $markdown } = useNuxtApp()
const formatHtml = computed(() => {
  return $markdown
    .render(formatMarkdown.value || '')
    .replace(/(<table[^>]*>([\s\S]*?)<\/table>)/g, function (_: any, p1: string) {
      return `<div class="app-markdown-table">${p1}</div>`
    })
})
const matchList = computed(() => {
  const regx = props.hasSubNav ? /<h[123].*?>(.*?)<\/h[123]>/g : /<h1.*?>(.*?)<\/h1>/g
  return formatHtml.value?.match(regx) || []
})
const navList = computed(() => {
  const list = []
  let currentContent: NavListConfig | null = null
  let subContent: NavListConfig | null = null
  for (const [index, item] of matchList.value.entries()) {
    const [title, url, type] = [
      decodeHTML(item.replace(/<[^>]+>/g, '')),
      decodeHTML(item.match(/href="([^"]*)"/)?.[1] || ''),
      decodeHTML(item.match(/<h([123])/)?.[1] || '')
    ]
    if (type === '1') {
      currentContent = {
        title,
        url,
        type,
        index,
        children: []
      }
      list.push(currentContent)
    }
    if (type === '2' && currentContent && props.hasSubNav) {
      subContent = {
        title,
        url,
        type,
        index,
        children: []
      }
      currentContent.children?.push(subContent)
    }
    if (type === '3' && subContent && props.hasSubNav) {
      subContent.children?.push({
        title,
        url,
        type,
        index,
        children: []
      })
    }
  }
  return list
})
const navFlatUrlList = computed(() => {
  return (
    matchList.value.map((item: any) => {
      return {
        url: decodeHTML(item.match(/href="([^"]*)"/)?.[1] || '')
      }
    }) || []
  )
})
const handleScroll = () => {
  if (Device().isMobile) return false
  if (toggling) {
    toggling = false
    return false
  }
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
  const index = navFlatUrlList.value.findIndex((item: { url: string }) => {
    try {
      const elem = item.url && item.url.trim() !== '#' && (document.querySelector(`${item.url}`) as HTMLElement)
      return elem && scrollTop < elem?.offsetTop - getLayoutHeaderHeight() * 2
    } catch (error) {
      console.error(error)
      return 0
    }
  })
  navActiveIndex.value = index === -1 ? navFlatUrlList.value.length - 1 : index - 1
}
const getLayoutHeaderHeight = () => {
  const elem = document.querySelector('.app-layout-header') as HTMLElement
  return elem?.offsetHeight || 0
}
const toggleNav = (idx: number) => {
  navActiveIndex.value = idx
  toggling = true
}
const openUsedBtn = () => {
  if (usedInfoShow.value) {
    hideUsedBtn()
    return
  }
  if (usedBtn.value) {
    const pos = usedBtn.value.getBoundingClientRect()
    const clientWidth = window.innerWidth
    if (pos.left + pos.width > clientWidth / 2) {
      usedListPlace.value = 'right'
    } else {
      usedListPlace.value = 'left'
    }
    usedInfoShow.value = true
  }
}
const hideUsedBtn = () => {
  usedInfoShow.value = false
}
watch(
  () => navActiveIndex.value,
  (value) => {
    const scrollHeight = markdownNav.value?.scrollHeight
    const offsetHeight = markdownNav.value?.offsetHeight || 0
    if (scrollHeight && offsetHeight < scrollHeight && value > -1) {
      const elem = document.querySelectorAll('.app-markdown-nav-item')[value] as HTMLElement
      const elemTop = elem.offsetTop
      markdownNav.value?.scrollTo(0, elemTop)
    }
  }
)
onMounted(async () => {
  await nextTick()
  if (process.client && !Device().isMobile) {
    // handleScroll()
    window.addEventListener('scroll', throttle(handleScroll, 10))
  }
})
onUnmounted(() => {
  window.removeEventListener('scroll', throttle(handleScroll, 10))
})
</script>
<style lang="scss">
@import '@/assets/css/markdown-theme.scss';
/* --- back --- */
.app-markdown-back {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  color: #babec5;
  cursor: pointer;
}
.app-markdown-back-button {
  width: 20px;
  height: 20px;
  background-color: #363a41;
  margin-right: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-markdown-back-icon {
  width: 6px;
  height: 10px;
  fill: #babec5;
  transition: fill 0.3s;
}
.app-markdown-back-name {
  font-size: 16px;
  line-height: 24px;
  transition: color 0.3s;
}
/* --- menu --- */
.app-markdown-menu-btn {
  display: none !important;
  width: 72px !important;
  height: 72px !important;
  border-radius: 0;
  position: absolute;
  left: 0;
  top: 40px;
  background: linear-gradient(135deg, #131313 calc(100% - 0.625rem), transparent 0.625rem) !important;
}
.app-markdown {
  display: flex;
  padding: 120px 0 0;
}
.app-markdown-inner {
  flex: 1;
  padding: 0 0 55px 50px;
  &.has__nav {
    max-width: 810px;
    padding: 0 80px 55px 50px;
  }
}

.app-markdown-hr {
  width: 100%;
  border-top: 1px solid #2b2d32;
}
.app-markdown-header {
  position: relative;
  padding: 0 24px;
  margin-bottom: 12px;
  &.has__back {
    margin-top: 10px;
  }
  &:before {
    content: '';
    position: absolute;
    width: 8px;
    height: 28px;
    top: 10px;
    left: 0;
    background-color: #ffba00;
  }
}
.app-markdown-title {
  font-size: 40px;
  line-height: 44px;
  color: #fff;
}
.app-markdown-subtitle {
  font-size: 26px;
  line-height: 1;
  color: #c8ccd3;
}
.app-markdown-used-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  background-color: transparent;
  .app-markdown-used-icon {
    width: 28px;
    height: 28px;
  }
}
.app-markdown-used-info {
  position: absolute;
  top: 100%;
  left: 8px;
  z-index: 1;
  display: flex;
  flex-direction: column;
  width: 226px;
  padding: 0 0 10px;
  color: #c8ccd3;
  font-weight: var(--font-regular);
  background-color: #2b2d32;
}
.app-markdown-used-title {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  line-height: 34px;
  color: #fff;
  padding: 0 10px;
  text-align: left;
}
.app-markdown-used-list {
  text-align: left;
  padding: 0 10px;
  max-height: 64px;
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #4d5158;
    border-radius: 0;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
}
.app-markdown-used-name {
  display: flex;
  font-size: 12px;
  line-height: 16px;
  padding-left: 4px;
  overflow: hidden;
  &::before {
    content: '';
    position: relative;
    top: 6px;
    flex-shrink: 0;
    width: 4px;
    height: 4px;
    margin-right: 4px;
    background-color: #ffba00;
    border-radius: 50%;
  }
}
.app-markdown-aside {
  position: relative;
  flex-shrink: 0;
  width: 278px;
  min-height: calc(100vh - 120px);
  padding: 0 0 0 46px;
  border-left: 1px solid #4d5158;
}
.app-markdown-index {
  font-weight: 700;
  color: #e8ecf3;
  font-size: 18px;
  line-height: normal;
  padding-left: 16px;
}
.app-markdown-aside-inner {
  position: sticky;
  top: 120px;
  bottom: 0;
  width: 100%;
}
.app-markdown-nav {
  position: relative;
  margin-top: 12px;
  max-height: calc(100vh - 160px);
  padding: 0 0 32px 16px;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 4px;
    display: none;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #4d5158;
    border-radius: 0;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
}
.app-markdown-marker {
  position: absolute;
  top: 14px;
  left: 0;
  width: 4px;
  height: 14px;
  background-color: #ffba00;
  transition: 0.3s;
}

/* --- markdown links --- */
.app-markdown-footer {
  display: flex;
  justify-content: space-between;
  color: #ffba00;
  font-size: 16px;
  line-height: 24px;
  max-width: 1000px;
}
.app-markdown-link {
  display: flex;
  align-items: center;
  height: 30px;
  max-width: 48%;
  visibility: hidden;
  &.visible {
    visibility: visible;
  }
  &:first-child {
    .app-markdown-link-icon {
      margin-right: 10px;
    }
  }
  &:last-child {
    flex-direction: row-reverse;
    .app-markdown-link-icon {
      margin-left: 10px;
      transform: rotate(180deg);
    }
  }
}
.app-markdown-link-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &.pre,
  &.next {
    display: none;
  }
}
.app-markdown-link-icon {
  flex-shrink: 0;
  width: 16px;
  height: 14px;
  margin-top: 2px;
  transition: 0.3s;
}
@media not all and (hover: none) {
  .app-markdown-back:hover {
    .app-markdown-back-icon {
      fill: #fff;
    }
    .app-markdown-back-name {
      color: #fff;
    }
  }
}
@media not all and (min-width: 1024px) {
  .app-markdown-aside {
    display: none;
  }
  .app-markdown-inner {
    &.has__nav {
      max-width: 100%;
    }
    max-width: 100%;
    padding: 0 32px 54px !important;
  }
  .app-markdown-footer {
    font-size: 26px;
    line-height: 34px;
  }
  .app-markdown-link-icon {
    width: 19px;
    height: 17px;
  }
  .app-markdown-header {
    margin-bottom: 0;
    padding: 8px 10px 12px 28px;
    min-height: 72px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    &:before {
      top: 18px;
    }
    &.has__back {
      margin-top: 0;
    }
    &.has__menu {
      &:before {
        display: none;
      }
      min-height: 136px;
      padding: 50px 0 16px 92px;
    }
  }
  .app-markdown-title {
    font-size: 40px;
    line-height: 44px;
  }
  .app-markdown-subtitle {
    margin-top: 10px;
  }
  .app-markdown-menu-btn {
    display: flex !important;
  }
  .app-markdown-menu-icon {
    width: 26px;
    height: 40px;
  }
  .app-markdown-link-text {
    display: none;
    &.pre,
    &.next {
      display: block;
    }
  }
  .app-markdown-footer {
    max-width: 100%;
  }
  /* --- back --- */

  .app-markdown-back-button {
    width: 28px;
    height: 28px;
  }
  .app-markdown-back-icon {
    width: 10px;
    height: 16px;
  }
  .app-markdown-back-name {
    font-size: 24px;
    line-height: 34px;
  }
  .app-markdown-used-btn {
    .app-markdown-used-icon {
      width: 34px;
      height: 34px;
    }
  }
  .app-markdown-used-info {
    width: 332px;
    &.left {
      left: 8px;
    }
    &.right {
      left: auto;
      right: 8px;
    }
  }
  .app-markdown-used-title {
    font-size: 26px;
    line-height: 42px;
    padding: 0 12px;
  }
  .app-markdown-used-list {
    max-height: calc(28px * 4);
    padding: 0 12px;
  }
  .app-markdown-used-name {
    font-size: 20px;
    line-height: 28px;
    padding-left: 8px;
    &:before {
      width: 4px;
      height: 4px;
      left: -2px;
      top: 12px;
      border-radius: 0;
    }
  }
}
</style>
